<template>
    <div id="report" :class="{'searched' : vehicle}">
        <div class="logo" v-if="!vehicle">
            车辆综检信息查询
        </div>
        <div class="main">
            <div class="plate-color-container" :class="'plate-color-' + plateColorCode">
                <select id="plateColorCode" name="plateColorCode" v-model="plateColorCode"
                        class="plate-color-selector">
                    <option value="2">黄牌</option>
                    <option value="1">蓝牌</option>
                </select>
            </div>
            <input type="text" v-model="vehicleNo" placeholder="请输入车牌进行查询" class="vehicle-no-input"
                   @input="inputVehicleNo"/>
            <a href="javascript:void(0)" class="search-btn" @click="search(-1)">
                <i class="el-icon el-icon-search"/>
            </a>
        </div>
        <div class="history">
            <div>示例：</div>
            <div class="entry" v-for="(vehicle, index) in histories" v-bind:key="vehicle.vehicleNo" >
                <div class="plate" :class="'plate-color-' + vehicle.plateColorCode" @click="search(index)">
                    <div class="vehicle-no">{{vehicle.vehicleNo}}</div>
                </div>
            </div>
        </div>
        <div class="result" v-if="vehicle">
            <div class="title">查询结果</div>
            <div class="entries" v-if="vehicle.vehicleNo">
                <div class="entry">
                    <div class="label">
                        号牌号码：
                    </div>
                    <div class="value">
                        <div class="plate" :class="'plate-color-' + vehicle.plateColorCode">
                            <div class="vehicle-no">{{vehicle.vehicleNo}}</div>
                        </div>
                    </div>
                </div>
                <div class="entry"></div>
                <div class="entry">
                    <div class="label">
                        车辆类型：
                    </div>
                    <div class="value">
                        {{ vehicle.vehicleType }}
                    </div>
                </div>
                <div class="entry">
                    <div class="label">
                        车身颜色：
                    </div>
                    <div class="value">
                        {{ vehicle.vehicleBodyColor }}
                    </div>
                </div>
                <div class="entry">
                    <div class="label">
                        使用性质：
                    </div>
                    <div class="value" :class="{ 'no-data' : !vehicle.vehicleNature }">
                        {{ vehicle.vehicleNature ? vehicle.vehicleNature : '未上传' }}
                    </div>
                </div>
                <div class="entry">
                    <div class="label">
                        燃油类型：
                    </div>
                    <div class="value">
                        {{ vehicle.fuelType }}
                    </div>
                </div>
                <div class="entry">
                    <div class="label">
                        检测日期：
                    </div>
                    <div class="value">
                        {{ vehicle.detectDate }}
                    </div>
                </div>
                <div class="entry">
                    <div class="label">
                        检测机构：
                    </div>
                    <div class="value">
                        {{ vehicle.dsName }}
                    </div>
                </div>
                <div class="entry">
                    <div class="label">
                        检测结果：
                    </div>
                    <div class="value">
                        {{ vehicle.evaluateresult_vehicletechrank }}
                    </div>
                </div>
                <div class="entry">
                    <div class="label">
                        审核情况：
                    </div>
                    <div class="value">
                        {{ vehicle.statusName }}
                    </div>
                </div>
                <div class="entry" style="width: 100%">
                    <div class="label">
                        照片：
                    </div>
                </div>
                <div class="entry" style="width: 100%">
                    <div class="value" style="display: flex; flex-direction: row; justify-content: flex-start">
                        <div class="pic-container">
                            <div class="caption">综合检查单</div>
                            <img class="pic" preview="1" preview-text="fdsafdafds"
                                 :large="vehicle.image_zhjcd ? 'https://image.qichezongjian.com/' + vehicle.image_zhjcd + '!origin' : noImageUrl"
                                 :src="vehicle.image_zhjcd ? 'https://image.qichezongjian.com/' + vehicle.image_zhjcd + '!thumbnail' : noImageUrl"/>
                        </div>
                        <div class="pic-container">
                            <div class="caption">驾驶证+合格标志</div>
                            <img class="pic" :src="vehicle.image_jszdyy? 'https://image.qichezongjian.com/' + vehicle.image_jszdyy + '!thumbnail' : noImageUrl"/>
                        </div>
                        <div class="pic-container">
                            <div class="caption">安全检查单</div>
                            <img class="pic" :src="vehicle.image_aqjcd ? 'https://image.qichezongjian.com/' + vehicle.image_aqjcd + '!thumbnail' : noImageUrl"/>
                        </div>
                        <div class="pic-container">
                            <div class="caption">制动检验工位</div>
                            <img class="pic" :src="vehicle.image_imageUrl1 ? 'https://image.qichezongjian.com/' + vehicle.image_imageUrl1 + '!thumbnail' : noImageUrl"/>
                        </div>
                        <div class="pic-container">
                            <div class="caption">灯光检验工位</div>
                            <img class="pic" :src="vehicle.image_imageUrl2 ? 'https://image.qichezongjian.com/' + vehicle.image_imageUrl2 + '!thumbnail' : noImageUrl"/>
                        </div>
                        <div class="pic-container">
                            <div class="caption">动力性检验工位</div>
                            <img class="pic" :src="vehicle.image_imageUrl3 ? 'https://image.qichezongjian.com/' + vehicle.image_imageUrl3 + '!thumbnail' : noImageUrl"/>
                        </div>
                    </div>
                </div>
            </div>
            <div class="error" v-else>
                查无此车，请检查车牌类型与车牌号码是否正确
            </div>
        </div>
    </div>
</template>

<script>
    import {openSearch} from "../../modules/services/basic-service";

    export default {
        name: 'report',
        data () {
            return {
                plateColorClass: 'yello',
                plateColorCode: 1,
                vehicleNo: '',
                noImageUrl: require('../../assets/no-img.png'),
                histories: [
                    {
                        plateColorCode: 1,
                        vehicleNo: '蒙D90597'
                    },
                    {
                        plateColorCode: 2,
                        vehicleNo: '蒙C28387'
                    }
                ],
                vehicle: null,
                searched: false
            }
        },
        methods: {
            inputVehicleNo () {
                this.vehicleNo = this.vehicleNo.toUpperCase()
            },
            search (index) {
                if (index >= 0) {
                    let selected = this.histories[index];
                    this.plateColorCode = selected.plateColorCode;
                    this.vehicleNo = selected.vehicleNo;
                }
                if (!this.plateColorCode || !this.vehicleNo) {
                    return
                }
                let self = this;
                openSearch(this.plateColorCode, this.vehicleNo).then(({body}) => {
                    self.searched = true;
                    if (body) {
                        self.vehicle = body;
                    } else {
                        self.vehicle = {}
                    }
                })
            }
        }
    }
</script>

<style scoped lang="stylus">
    #report {
        padding: calc(50vh - 300px) 0;
        &.searched {
            padding: 20px 0
        }
        .logo {
            color: #2fa4e7
            font-size: 32px;
            margin: 0 auto;
            width: 600px;
            text-align:center;
            margin-bottom: 30px;
            font-weight: bold;
        }
        .main {
            width: 600px;
            margin: 0 auto;
            height: 80px;
            line-height: 80px;
            border: 1px solid #ccc;
            border-radius 10px;
            display flex;
            justify-content space-between
            vertical-align middle;
        }
        .history {
            width: 600px;
            margin: 20px auto;
            display: flex;
            justify-content flex-start
            flex-wrap: wrap
            align-items center
            .entry {
                margin-right: 10px;
                cursor: pointer;
            }
        }
        .plate {
            text-align: center;
            line-height: 24px;
            width: 100px;
        }
        .vehicle-no {
            border: 2px solid white;
            font-weight: bold;
            border-radius: 3px;
            padding: 2px;
            font-size: 14px;
        }
        .plate-color-1, .plate-color-2 {
            border-radius: 5px;
        }
        .plate-color-1 {
            border: 1px solid #1B3288;
        }
        .plate-color-2 {
            border: 1px solid #fc0;
        }
        .plate-color-1 .vehicle-no {
            border-color: white;
            background: #1B3288;
            color: white;
        }
        .plate-color-2 .vehicle-no {
            border-color: black;
            background: rgb(255, 190, 0);
            color: black;
        }
        .search-btn {
            font-size: 40px;
            height: 40px;
            line-height: 40px;
            margin-top: 20px;
            margin-right: 20px;
            cursor: pointer;
            color: #aaa;
            &:hover {
                color: #000;
            }
        }
        .plate-color-container {
            margin-top: 20px;
            width: 120px;
            height: 40px;
            line-height: 40px;
            margin-left: 20px;
            border-radius: 4px;
            outline none;
            padding-right: 1px;
            .plate-color-selector {
                width: 118px;
                height: 38px;
                line-height: 38px;
                padding: 0 20px;
                background: rgba(0, 0, 0, 0);
                outline none;
                font-size: 20px;
                font-weight: bold;
                border-radius: 5px;
                margin-top: 1px;
                margin-left: 1px;
                option:nth-child(1) {
                    background: #fc0
                    color: #000
                }
                option:nth-child(2) {
                    background: #1B3288;
                    color: #fff;
                }
            }
            &.plate-color-1 {
                background #1B3288;
                .plate-color-selector {
                    border: 2px solid #fff;
                    color: #fff;
                }
            }
            &.plate-color-2 {
                background: #fc0;
                .plate-color-selector {
                    border: 2px solid #000;
                    color: #000;
                }
            }
        }
        .vehicle-no-input {
            margin-top: 20px;
            outline none;
            width: 430px;
            height: 40px;
            text-align left;
            line-height 40px;
            font-size: 20px;
            border none;
            margin-left: 20px;
        }
        .result {
            width: 800px;
            margin: 70px auto 20px;
            box-shadow: 0px 0px 8px 0px rgba(145, 142, 142, 1);
            padding: 30px 20px;
            position: relative;
            .title {
                position: absolute;
                box-shadow: 0px 0px 8px 0px rgba(145, 142, 142, 1);
                top: -29px;
                left: 20px;
                font-size: 24px;
                background: #fff;
                padding: 10px;
            }
            .entries {
                display: flex;
                flex-wrap wrap;
                .entry {
                    display: flex;
                    align-items center
                    justify-content flex-start
                    width: 50%;
                    min-height: 60px;
                    line-height: 60px;
                    .label {
                        font-weight: bold;
                    }
                    .value {
                        color: rgb(0, 0, 204);
                        font-weight: bold;
                        &.no-data {
                            color: #ccc;
                        }
                    }
                }
            }
            .pic-container {
                height: 120px;
                width: 100px;
                border: 1px solid #ccc;
                position: relative
                margin-right: 10px;
                cursor: pointer;
                .caption {
                    position: absolute;
                    bottom: 0px;
                    height: 20px;
                    line-height: 20px;
                    background rgba(0, 0, 0, 0.6);
                    font-size: 12px;
                    text-align center;
                    color: #fff;
                    width: 100%;
                }
                .pic {
                    height: 100px;
                }
            }
        }
        .error {
            color: red;
        }
    }
</style>